import React, { useEffect, useState } from "react";
import Table from 'react-bootstrap/Table';
import { MemorizationType } from "../../enums/status-enums";
import { SortMemorizationType } from "../../helpers/sort-helper";
import { IMemorizationChapter } from "../../models/memorization-chapter";

export interface IMemorizationChapterViewTable{
  memorizationChapters: IMemorizationChapter[];
}

export function MemorizationChapterViewTable(props: IMemorizationChapterViewTable){

  const {memorizationChapters} = props;

  const [memorizationChaptersState, setMemorizationChapters] = useState(memorizationChapters 
    ? memorizationChapters : [] as IMemorizationChapter[] );

  useEffect(()=>{
    if(memorizationChapters){
      setMemorizationChapters(memorizationChapters);
    }
  },[memorizationChapters]);

  return (
    <>
           {memorizationChaptersState.length > 0 &&  <Table striped bordered hover>
            <thead>
              <tr>
                <th style={{ background:"#197770", color:"white", fontSize:"14px", fontFamily: 'Heiti SC, sans-serif'}}>Surah</th>
                <th style={{ background:"#197770", color:"white", fontSize:"14px", fontFamily: 'Heiti SC, sans-serif'}}>Fra</th>
                <th style={{ background:"#197770", color:"white", fontSize:"14px", fontFamily: 'Heiti SC, sans-serif'}}>Til</th>
                <th style={{ background:"#197770", color:"white", fontSize:"14px", fontFamily: 'Heiti SC, sans-serif'}}>Type</th>
              </tr>
            </thead>
            <tbody style={{fontFamily: 'Heiti SC, sans-serif', fontSize:"12px"}}>
            {memorizationChaptersState.sort(SortMemorizationType).map((memorizationChapter, index) => (
                      <tr  onClick={()=> {}} key={index}>
                          <td>
                            {memorizationChapter.chapterDisplayName}
                          </td>
                          <td>
                            {memorizationChapter.fromAyah}
                          </td>
                          <td>
                            {memorizationChapter.toAyah}
                          </td>
                          <td>
                            {memorizationChapter.memorizationType === MemorizationType.Hifz ? "Hifz" : "Murajara"}
                          </td>
                      </tr>
                    ))}
            </tbody>
          </Table>
         } 
       
    </>
  );
}

